import script from "./ButtomTheme.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtomTheme.vue?vue&type=script&setup=true&lang=js"

import "./ButtomTheme.vue?vue&type=style&index=0&id=75eecd84&lang=css"

const __exports__ = script;

export default __exports__